//modulo home exibição de pianos para vendas
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaChevronLeft, FaChevronRight, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../../../assets/css/pianovendas.css';

const PianosVenda = () => {
  const [pianos, setPianos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    const fetchPianos = async () => {
      try {
        const response = await fetch('https://pianoswaldir.com.br/api/pianos.php?action=list&status=disponivel');
        const data = await response.json();
        setPianos(data);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao carregar pianos:', error);
        setLoading(false);
      }
    };

    fetchPianos();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === pianos.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? pianos.length - 1 : prevIndex - 1
    );
  };

  if (loading) {
    return (
      <div className="pianos-loading">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
  
        </motion.div>
        <p>Carregando pianos disponíveis...</p>
      </div>
    );
  }

  if (pianos.length === 0) {
    return (
      <div className="no-pianos">

        <p>Nenhum piano disponível no momento. Em breve novidades!</p>
      </div>
    );
  }

  return (
    <section className="pianos-section">
      <div className="section-header">
        <h2>Pianos Disponíveis</h2>
        <p>Conheça nossos pianos disponíveis para venda</p>
      </div>

      <div className="pianos-container">
        <button className="nav-button-pv prev" onClick={prevSlide}>
          <FaChevronLeft />
        </button>

        <div className="pianos-carousel">
          {pianos.slice(currentIndex, currentIndex + 3).map((piano, index) => (
            <motion.div
              key={piano.id}
              className="piano-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={`/pianos/${piano.id}`} className="piano-link">
                <div className="piano-image-container-venda">
                  <img 
                    src={piano.foto_principal} 
                    alt={`Piano ${piano.marca} ${piano.modelo}`} 
                    className="piano-image"
                  />
                  <div className="piano-overlay">
                    <FaSearch size={24} />
                    <span>Ver Detalhes</span>
                  </div>
                </div>
                <div className="piano-info">
                  <h3>{piano.marca} {piano.modelo}</h3>
                  <p className="piano-price-pv">
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    }).format(piano.valor)}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <button className="nav-button-pv next" onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>

      <div className="view-all">
        <Link to="/pianos" className="view-all-link">
          Ver Todos os Pianos
        </Link>
      </div>
    </section>
  );
};

export default PianosVenda;